import React, { useState } from 'react';
import { FileTextIcon, HelpCircleIcon, ClipboardListIcon, GlobeIcon, ChevronDownIcon } from 'lucide-react';
interface TopPanelProps {
  totalPrice: number;
  onGetQuote: () => void;
  onOpenCart: () => void;
  cartItemCount: number;
}
export const TopPanel = ({
  totalPrice,
  onGetQuote,
  onOpenCart,
  cartItemCount
}: TopPanelProps) => {
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('ET');
  const languages = [{
    code: 'ET',
    name: 'Eesti'
  }, {
    code: 'EN',
    name: 'English'
  }, {
    code: 'FI',
    name: 'Suomi'
  }, {
    code: 'SWE',
    name: 'Svenska'
  }];
  return <div className="absolute top-0 left-0 right-0 flex justify-between items-center p-4 bg-white bg-opacity-80 backdrop-blur-sm shadow-md" data-id="element-129">
      <div className="flex items-center gap-3" data-id="element-130">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/whbgfrehx6ps1aprso6cfc/55f2b4f5-4e86-4fac-89d6-115a61ec8f52/Logofull-for-white-back-250x150.png" alt="AVAR" className="h-12 w-auto object-contain px-2" data-id="element-131" />
      </div>
      <div className="flex items-center gap-6" data-id="element-132">
        {/* Price display with cart button */}
        <div className="flex items-center bg-white rounded-md shadow-sm" data-id="element-133">
          <div className="px-4 py-2.5" data-id="element-134">
            <div className="text-xs text-gray-500" data-id="element-135">LIGIKAUDNE HIND</div>
            <div className="text-xl font-bold" data-id="element-136">
              {totalPrice.toLocaleString()} €
            </div>
          </div>
          <div className="border-l border-gray-200 h-[80%] mx-1" data-id="element-137"></div>
          <button onClick={onOpenCart} className="relative px-3 py-3.5 hover:bg-gray-100 rounded-r-md transition-colors h-full flex items-center" title="Pakkumise valikud" data-id="element-138">
            <ClipboardListIcon size={20} data-id="element-139" />
            {cartItemCount > 0 && <span className="absolute -top-1 -right-1 bg-green-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-140">
                {cartItemCount}
              </span>}
          </button>
        </div>
        {/* Actions */}
        <button onClick={onGetQuote} className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md transition-colors flex items-center gap-2" data-id="element-141">
          <FileTextIcon size={16} data-id="element-142" />
          <span data-id="element-143">Saa pakkumine</span>
        </button>
        {/* Language Selector */}
        <div className="relative" data-id="element-144">
          <button className="flex items-center gap-1 p-2 hover:bg-gray-100 rounded-md transition-colors" onClick={() => setIsLanguageOpen(!isLanguageOpen)} data-id="element-145">
            <GlobeIcon size={18} data-id="element-146" />
            <span className="font-medium text-sm" data-id="element-147">{currentLanguage}</span>
            <ChevronDownIcon size={16} className={`transition-transform ${isLanguageOpen ? 'rotate-180' : ''}`} data-id="element-148" />
          </button>
          {isLanguageOpen && <div className="absolute right-0 mt-1 bg-white shadow-lg rounded-md py-1 w-32 z-50" data-id="element-149">
              {languages.map(lang => <button key={lang.code} className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 transition-colors flex items-center justify-between ${currentLanguage === lang.code ? 'text-orange-500 font-medium' : ''}`} onClick={() => {
            setCurrentLanguage(lang.code);
            setIsLanguageOpen(false);
          }} data-id="element-150">
                  <span data-id="element-151">{lang.name}</span>
                  {currentLanguage === lang.code && <div className="w-2 h-2 bg-orange-500 rounded-full" data-id="element-152"></div>}
                </button>)}
            </div>}
        </div>
        {/* Help */}
        <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-153">
          <HelpCircleIcon size={20} data-id="element-154" />
        </button>
      </div>
    </div>;
};